import { Heading, Label, Value, PaddedContent, general} from 'daymap-library'
import { Text } from '@fluentui/react';
import Alert, { ALERT_TYPE } from  '../../components/Alert/Alert';
import { useAuth } from '../../helpers/authContext';
import {useNavigate, useParams } from 'react-router-dom';

function RoomSignInDetails({ID, Name, Subject, EventDate, StartTime, EndTime, SignInTime, Success, Error}){

    return (
    <div>
        <Heading><Text variant="large">Sign In Details</Text></Heading>
        {!Success ? <></> :
            <PaddedContent>
            <Label position="Left" text="Name:">
                <Value>{Name}</Value>
            </Label>
            <Label position="Left" text="Subject:">
                <Value>{Subject}</Value>
            </Label>
            <Label position="Left" text="Date:">
                <Value>{new Date(EventDate).toLocaleDateString()}</Value>
            </Label>
            <Label position="Left" text="Sign In Time:">
                <Value>{new Date(SignInTime).toLocaleTimeString()}</Value>
            </Label>    
            <Label position="Left" text="Start Time:">
                <Value>{new Date(StartTime).toLocaleTimeString()}</Value>
            </Label>
            <Label position="Left" text="End Time:">
                <Value>{new Date(EndTime).toLocaleTimeString()}</Value>
            </Label>
            </PaddedContent>
        }
        <SignInResult message={Success ? 'Successful' : 'Failed'} error={Error}></SignInResult>
    </div>
    )
}

const SignInResult = ({message, error}) => {
  const { settings } = useAuth();
  const navigate = useNavigate();
  const { roomId } = useParams();
  const [ secondsTilRedirect ] = general.useCountdown({ seconds: settings.KioskRedirectDelay, onZero: () => navigate(`/room/${roomId}`) });

  if(!(settings.KioskRedirectDelay > 0))
  {
    navigate(`/room/${roomId}`);
    return "";
  }

  return  <Alert type={error ? ALERT_TYPE.Error : ALERT_TYPE.Success} heading={'Room Sign In ' + message}>
            <div>{error ?? error}</div>
            Returning to student select in {secondsTilRedirect} seconds.
          </Alert>
}

export default RoomSignInDetails;